import store from '@/store'

const IP1 = window.IP1 || 'iot1'
const IP2 = window.IP2 || 'iot2'
const EUROPEDOMAINS = `https://${IP1}.opple.com`
const NON_EUROPEDOMAINS = `https://${IP2}.opple.com`

const hostname = window.location.hostname
const isInEuropeDomain = hostname.indexOf(IP1) !== -1
const isInChinaDomain = hostname.indexOf(IP2) !== -1

/* 
 * form 表单-密码和验证码登录
 * countryform 国家的表单
 * userRs 登录成功以后返回的结果
*/
export function hanleDomainWhenClickLoginBtn (form,countryform,userRs) {
  let jumpUrl = ''
  const queryMap = {
    u: form.name, //用户名
    p: form.eyetxt1, //密码
    v: form.email, //验证码
    t: userRs.Token, //token
    c: countryform.countryValue, //国家
    f: store.state.chooseIsEurope //跳转判断
  }

  // if (store.state.chooseIsEurope) {
  //   window.defaultDomaims = EUROPEDOMAINS
  //   if (!isInEuropeDomain) { //   'http://localhost:8080'
  //     jumpUrl = spellUrl(EUROPEDOMAINS, queryMap)
  //   }
  // } else {
  //   window.defaultDomaims = NON_EUROPEDOMAINS
  //   if (!isInChinaDomain) {
  //     jumpUrl = spellUrl(NON_EUROPEDOMAINS, queryMap)
  //   }
  // }
  jumpUrl = spellUrl(window.defaultDomaims || window.location.origin, queryMap)
  return jumpUrl
}

function spellUrl (domain, queryMap) {
  let jumpUrl = `${domain}?`
  Object.keys(queryMap).forEach(key => {
    if (queryMap[key] !== undefined) {
      jumpUrl += `${key}=${encodeURIComponent(String(queryMap[key]))}&`
    }
  })

  return jumpUrl.substring(0, jumpUrl.length - 1)
}
